import {createSelector} from 'reselect';
import {isMobile} from './DeviceSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, isMobile],
  (settings, mobile) => (
    !!(mobile && settings.app_download_buttons?.mobile_redirect_url)
    || !!(!mobile && settings.app_download_buttons?.desktop_redirect_url)
  ),
);
